<template>
  <div>
    <hero-bar>
      Find Job
    </hero-bar>
    <section class="section is-main-section">
      <nav class="panel">
        <p class="panel-heading">
          Repositories
        </p>
        <div class="panel-block">
          <p class="control has-icons-left">
            <input class="input" type="text" placeholder="Search" />
            <span class="icon is-left">
              <i class="fas fa-search" aria-hidden="true"></i>
            </span>
          </p>
        </div>
        <p class="panel-tabs">
          <a class="is-active">All</a>
          <a>Public</a>
          <a>Private</a>
          <a>Sources</a>
          <a>Forks</a>
        </p>
        <a class="panel-block is-active">
          <span class="panel-icon">
            <i class="fas fa-book" aria-hidden="true"></i>
          </span>
          bulma
        </a>
        <a class="panel-block">
          <span class="panel-icon">
            <i class="fas fa-book" aria-hidden="true"></i>
          </span>
          marksheet
        </a>
        <a class="panel-block">
          <span class="panel-icon">
            <i class="fas fa-book" aria-hidden="true"></i>
          </span>
          minireset.css
        </a>
        <a class="panel-block">
          <span class="panel-icon">
            <i class="fas fa-book" aria-hidden="true"></i>
          </span>
          jgthms.github.io
        </a>
        <a class="panel-block">
          <span class="panel-icon">
            <i class="fas fa-code-branch" aria-hidden="true"></i>
          </span>
          daniellowtw/infboard
        </a>
        <a class="panel-block">
          <span class="panel-icon">
            <i class="fas fa-code-branch" aria-hidden="true"></i>
          </span>
          mojs
        </a>
        <label class="panel-block">
          <input type="checkbox" />
          remember me
        </label>
        <div class="panel-block">
          <button class="button is-link is-outlined is-fullwidth">
            Reset all filters
          </button>
        </div>
      </nav>
    </section>
  </div>
</template>

<script>
import mapValues from "lodash/mapValues";

// import axios from 'axios'

import HeroBar from "@/components/HeroBar";
export default {
  name: "Forms",
  components: { HeroBar },
  data() {
    return {
      isLoading: false,
      isImageModalActive: false,
      form: {
        name: null,
        email: null,
        phone: null,
        status: "Booked",
        subject: null,
        notes: null,
        radio: null,
        requestedPickup: new Date()
      },
      statuses: [
        "Booked",
        "Scheduled",
        "Loaded",
        "Delivered",
        "Complete",
        "Invoiced"
      ],
      dataC: [
        {
          id: 1,
          qty: "Jesse",
          product: "Simmons",
          unit: "2016-10-15 13:43:27",
          notes: "Male",
          rate: "5",
          estKm: 200,
          estWeight: 2000,
          status: "Complete"
        },
        {
          id: 2,
          qty: "John",
          product: "Jacobs",
          unit: "2016-12-15 06:00:53",
          notes: "Male",
          rate: "8",
          estKm: 2100,
          estWeight: 2400,
          status: "Incomplete"
        }
      ],
      columns: [
        { field: "id", label: "ID", width: "40", numeric: true },
        { field: "qty", label: "Qty" },
        { field: "product", label: "Product" },
        { field: "unit", label: "Unit", centered: true },
        { field: "notes", label: "Notes" },
        { field: "rate", label: "Rate" },
        { field: "estKm", label: "Est KM" },
        { field: "estWeight", label: "Est Weight" },
        { field: "status", label: "Status" }
      ],
      showAddModal: false
    };
  },
  computed: {
    titleStack() {
      return ["Admin", "Forms"];
    }
  },
  methods: {
    submit() {
      var x = "";
      // for (x in this.dataC) {
      //  alert(this.dataC[x].product)
      // }
      for (x in this.data) {
        alert(this.data[x].first_name);
      }
    },
    openAddModal() {
      this.showAddModal = true;
    },
    reset() {
      this.form = mapValues(this.form, item => {
        if (item && typeof item === "object") {
          return [];
        }
        return null;
      });

      this.$buefy.snackbar.open({
        message: "Reset successfully",
        queue: false
      });
    },
    myEvent(record) {
      alert("cc" + record.id);
      this.openAddModal();
    },

    myEventx(record) {
      alert("xx" + record.id);
      this.openAddModal();
    },
    closeModal() {
      this.showAddModal = false;
      this.showEditModal = false;
    },
    saveModal() {
      this.showAddModal = false;
      this.showEditModal = false;
      this.dataC.push({
        id: 3,
        qty: this.$store.state.qty,
        product: this.$store.state.product,
        unit: this.$store.state.unit,
        notes: this.$store.state.notes,
        rate: this.$store.state.rate,
        estKm: this.$store.state.km,
        estWeight: this.$store.state.weight,
        status: this.$store.state.status
      });
    }
  }
};
</script>
